import { render, staticRenderFns } from "./AssetBankShimmer.vue?vue&type=template&id=bef2727a&scoped=true"
import script from "./AssetBankShimmer.vue?vue&type=script&lang=js"
export * from "./AssetBankShimmer.vue?vue&type=script&lang=js"
import style0 from "./AssetBankShimmer.vue?vue&type=style&index=0&id=bef2727a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef2727a",
  null
  
)

export default component.exports